export const getMauerData = () => ({
  name: "Mauer",
  region: "Wien",
  country: "Autriche",
  description: "Mauer est une zone viticole urbaine de Wien avec des vignobles établis produisant des vins aromatiques. Cette région bénéficie d'un climat continental avec des microclimats, créant des conditions favorables pour des vins expressifs.",
  type: "subregion",
  area: "100 ha",
  production: "0.005 million hectolitres",
  climate: "Climat continental avec microclimats, étés modérés et hivers froids",
  soil: "Sols alluviaux, calcaires, excellente diversité géologique",
  characteristics: {
    climate: "Climat continental avec microclimats, étés modérés et hivers froids",
    soil: "Sols alluviaux, calcaires, excellente diversité géologique",
    viticulture: "Viticulture urbaine, rendements limités, qualité privilégiée"
  },
  wineStyles: {
    white: "Vins blancs aromatiques et expressifs, avec une acidité vive",
    red: "Vins rouges légers et fruités, avec des tanins fins",
    rosé: "Rosés délicats et fruités, parfaits pour l'apéritif",
    sparkling: "Vins effervescents de méthode traditionnelle"
  },
  history: "La viticulture à Mauer remonte à l'époque romaine. La zone a développé une réputation pour ses vins aromatiques, notamment les vins blancs. Aujourd'hui, Mauer est reconnue pour sa diversité de styles et sa qualité constante.",
  foodPairing: "Cuisine viennoise traditionnelle, poissons, fromages frais, cuisine internationale",
  grapeVarieties: [
    {
      name: "Grüner Veltliner",
      percentage: "45%",
      description: "Cépage emblématique d'Autriche, produisant des vins blancs secs et aromatiques",
      characteristics: "Sec, aromatique, acidité vive",
      wineStyles: "Sec, léger, aromatique"
    },
    {
      name: "Riesling",
      percentage: "25%",
      description: "Cépage blanc produisant des vins secs et minéraux",
      characteristics: "Sec, minéral, acidité vive",
      wineStyles: "Sec, moyen-corps, complexe"
    },
    {
      name: "Zweigelt",
      percentage: "20%",
      description: "Cépage rouge produisant des vins légers et aromatiques",
      characteristics: "Léger, aromatique, tanins fins",
      wineStyles: "Sec, léger, aromatique"
    },
    {
      name: "Pinot Noir",
      percentage: "5%",
      description: "Cépage rouge produisant des vins légers et élégants",
      characteristics: "Léger, élégant, tanins fins",
      wineStyles: "Sec, léger, élégant"
    },
    {
      name: "Autres",
      percentage: "5%",
      description: "Autres cépages incluant des cépages autochtones",
      characteristics: "Diversifiés, expérimentaux",
      wineStyles: "Variés selon le cépage"
    }
  ],
  mapAreas: [
    { region: "Mauer", x: 16.3, y: 48.1, color: "#8a4a8a", size: 1 }
  ]
}); 